/* eslint-disable react/prop-types */
import React from 'react'

import { Dialog, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import MuiDialogTitle from '@mui/material/DialogTitle'
import MuiDialogContent from '@mui/material/DialogContent'
import DialogActions from '@mui/material/DialogActions'
import MikeButton from '@mike/mike-shared-frontend/mike-button'
import DialogTitle from './DialogTitle'

const StyledTitle = styled(Typography)(({ theme }) => ({
  fontWeight: 'bold',
  paddingBottom: theme.spacing(1),
  paddingTop: theme.spacing(1)
}))

const StyledDialogContent = styled(MuiDialogContent)(({ theme }) => ({
  maxWidth: 378,
  paddingBottom: theme.spacing(3),
  paddingRight: theme.spacing(3),
  backgroundColor: theme.palette.background.paper
}))

const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  padding: theme.spacing(1),
  color: theme.palette.background.paper,
  height: theme.spacing(2),
  width: '100%'
}))

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.background.paper,
  paddingBottom: theme.spacing(3),
  paddingRight: theme.spacing(3),
  width: '100%'
}))

interface IProps {
  open: boolean
  onCancel?: () => void
  onOk: () => void
  children?: React.ReactNode
  title?: string
  message?: string
  cancel?: string
  ok?: string
  hideCancelButton?: boolean
  disableDismiss?: boolean
}

const ConfirmationDialog = (props: IProps) => {
  const {
    children,
    open,
    message,
    title,
    ok = 'Ok',
    cancel = 'Cancel',
    onCancel,
    onOk,
    disableDismiss
  } = props

  return (
    <Dialog
      maxWidth={'xs'}
      onClose={disableDismiss ? undefined : onCancel}
      open={open}
      scroll={'paper'}
    >
      {!disableDismiss && onCancel && (
        <StyledDialogTitle>
          <DialogTitle onClose={onCancel} />
        </StyledDialogTitle>
      )}
      {children ? (
        children
      ) : (
        <StyledDialogContent>
          <StyledTitle variant="h3">{title}</StyledTitle>
          <Typography variant="body2">{message}</Typography>
        </StyledDialogContent>
      )}
      <StyledDialogActions>
        {!props.hideCancelButton && onCancel && (
          <MikeButton onClick={onCancel} buttontype="text">
            {cancel}
          </MikeButton>
        )}
        <MikeButton
          style={
            props.hideCancelButton ? { width: '95%' } : { width: 'default' }
          }
          onClick={onOk}
          buttontype="primary"
        >
          {ok}
        </MikeButton>
      </StyledDialogActions>
    </Dialog>
  )
}

export default ConfirmationDialog
